import {Provider} from 'react-redux';
import {renderElement} from '@Utils/root-element.util';
import type {EmailMakerAiRedesignPromptBoxProps} from '@Components/email-maker-ai-redesign-prompt-box/email-maker-ai-redesign-prompt-box';
import {EmailMakerAiRedesignPromptBox} from '@Components/email-maker-ai-redesign-prompt-box/email-maker-ai-redesign-prompt-box';
import type {EmailMakerAiRewritePromptBoxProps} from '@Components/email-maker-ai-rewrite-prompt-box/email-maker-ai-rewrite-prompt-box';
import {EmailMakerAiRewritePromptBox} from '@Components/email-maker-ai-rewrite-prompt-box/email-maker-ai-rewrite-prompt-box';

window.PMW.mergePMW(PMW, {
  renderEmailMakerAiRedesignPromptBox(containerElement: HTMLElement, opts: EmailMakerAiRedesignPromptBoxProps) {
    renderElement(
      containerElement,
      <Provider store={window.PMW.redux.store}>
        <EmailMakerAiRedesignPromptBox {...opts} />
      </Provider>
    );
  },
});

window.PMW.mergePMW(PMW, {
  renderEmailMakerAiRewritePromptBox(containerElement: HTMLElement, opts: EmailMakerAiRewritePromptBoxProps) {
    renderElement(
      containerElement,
      <Provider store={window.PMW.redux.store}>
        <EmailMakerAiRewritePromptBox {...opts} />
      </Provider>
    );
  },
});
